/** 
* 自动生成文件，请勿修改 
* @name: 用章：用章申请审核流水
* @description: 用章：用章申请审核流水
* @create: 2024/1/11 下午4:25:21
* @swagger: 2.0
* 合计:6条
*/ 
 
import APIObject from "../utils/APIObject.js" 
const sealApplyApproval = { 
	/** 1 summary:查询--单条数据	method:post */ 
	queryOne : new APIObject("/api/sealApplyApproval/queryOne.do"), 
	/** 2 summary:查询所有	method:post */ 
	queryAll : new APIObject("/api/sealApplyApproval/queryAll.do"), 
	/** 3 summary:用章申请审核流水-单条删除	method:post */ 
	delete : new APIObject("/api/sealApplyApproval/delete.do"), 
	/** 4 summary:用章申请审核流水-批量删除	method:post */ 
	batchDelete : new APIObject("/api/sealApplyApproval/batchDelete.do"), 
	/** 5 summary:申领申请-审核	method:post */ 
	audit : new APIObject("/api/sealApplyApproval/audit.do"), 
	/** 6 summary:用章申请审核流水-分页查询	method:post */ 
	queryPage : new APIObject("/api/sealApplyApproval/queryPage.do"), 
};
export default sealApplyApproval;